import React from 'react';
import { KeenIcon } from '@/components';
import { toAbsoluteUrl } from '@/utils';
import { BrandedVisual } from '@/layouts/auth-branded';

interface NoOffersContentProps {
  onAddNewOffer: () => void;
}

const NoOffersContent: React.FC<NoOffersContentProps> = ({ onAddNewOffer }) => {
  return (
    <div className="grid lg:grid-cols-3 gap-5 lg:gap-7.5">
      <div className="lg:col-span-3">
        <div className="mb-7.5">
          <div className="card">
            <div className="card-body px-10 py-7.5 lg:pr-12.5 flex flex-col justify-start">
              <div className="flex flex-wrap md:flex-nowrap items-start gap-6 md:gap-10">
                {/* Text column – narrower */}
                <div className="flex flex-col gap-3 md:flex-[0_0_55%]">
                  <h1 className="text-2xl font-semibold text-gray-900">Erstes Angebot erstellen</h1>

                  <h2 className="text-xl font-semibold text-gray-900">
                    Strukturierter Einstieg in Ihre Angebotsarbeit
                  </h2>

                  <p className="text-sm text-gray-700 leading-5.5">
                    Ein Angebot beschreibt Leistungsumfang, Zielsetzung und Rahmenbedingungen. Es
                    dient als gemeinsame Grundlage für Abstimmung und Umsetzung.
                  </p>

                  <p className="text-sm text-gray-700 leading-5.5">
                    Sie können Inhalte eingeben, Dokumente hochladen oder bestehende Unterlagen als
                    Ausgangspunkt verwenden. Die Inhalte werden strukturiert und weiterverwendbar
                    aufbereitet.
                  </p>

                  <p className="text-sm text-gray-700 leading-5.5">
                    Es ist keine Vorbereitung erforderlich. Sie können direkt beginnen.
                  </p>
                </div>

                {/* Visual column – wider */}
                <div className="md:flex-[0_0_45%] flex justify-center">
                  <BrandedVisual />
                </div>
              </div>
            </div>

            <div className="card-footer justify-center">
              <button onClick={onAddNewOffer} className="btn btn-link" type="button">
                Erstes Angebot erstellen
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { NoOffersContent };
